import React from 'react';
import { ArrowRightIcon, FileTextIcon } from 'lucide-react';
import { Container } from './ui/Container';
export function GrantsCallout() {
  return <section id="grants" className="bg-iris-green text-iris-black py-12" data-id="element-97">
      <Container data-id="element-98">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8" data-id="element-99">
          <div className="flex items-start gap-6" data-id="element-100">
            <div className="p-3 bg-black/10 rounded-full shrink-0" data-id="element-101">
              <FileTextIcon className="w-8 h-8" data-id="element-102" />
            </div>
            <div data-id="element-103">
              <h2 className="text-2xl md:text-3xl font-display font-bold uppercase tracking-wide mb-2" data-id="element-104">
                Available grants may fund your IRIS deployment.
              </h2>
              <p className="font-medium opacity-90 max-w-2xl" data-id="element-105">
                Many agencies leverage state and federal grant programs (such as
                the Florida Immigration Enforcement Grant) to procure
                intelligence workflow platforms.
              </p>
            </div>
          </div>

          <a href="#contact" className="shrink-0 inline-flex items-center gap-2 bg-iris-black text-white px-6 py-3 font-display uppercase tracking-wider hover:bg-black transition-colors" data-id="element-106">
            View Available Grants <ArrowRightIcon className="w-4 h-4" data-id="element-107" />
          </a>
        </div>
      </Container>
    </section>;
}